import React from 'react';

export const LoadingComponent: React.FC<{ width }> = ({ width }) => {
    return (
        <div 
            style={{
                position: "absolute",
                backgroundColor: "black",
                opacity: 0.1,
                width,
                height: "100%",
                justifyContent: "center",
                alignItems: "center",
                display: "flex",
                zIndex: 1
            }}
        >
            <img alt={'loading'} src={"/public/assets/loading-component.gif"} style={{ height: "14px" }}/>
        </div>
    )
}